import { createFileRoute } from '@tanstack/react-router';
import { ApiDocsPage } from '@/components/ApiDocsPage';

export const Route = createFileRoute('/_authenticated/api-docs')({
  component: ApiDocsPage,
});
